import { styled } from "styled-components";

export const FoodCard = styled.div`
  width: 400px;
  font-size: 14px;
  border: 1px solid #7b747480;
  padding: 1rem;
  margin: 1rem;
  display: flex;
  box-shadow: 1px 1px 1px 1px #cac5c53b;
`;

export const FoodCtnr = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;
export const Header = styled.div`
  background-color: #ffff;
  box-shadow: 1px 1px 1px 1px gray;
  height: 52px;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-around;
`;
